export default "__VITE_ASSET__CUZI8COH__"